// GENERATED by tools/levels (pnpm levels:build). Do not edit by hand.
import type { ColorPack } from "./schema.ts";

export const COLOR_CONTENT_VERSION = "colors-1.0.0";

/** sha256 of each frozen chapter pack, checked by `pnpm levels:check`. */
export const COLOR_PACK_SHA256: Readonly<Record<number, string>> = {
  1: "c495769e5b0cb94e2be527ba8d2980ed62d006e3880d98e363afc30f3afe0308",
  2: "8516fee1e73e8e622d4a0efe4d554d0b2fd623b42daa545ca2f8d243cbd5613e",
  3: "a1950a92e55a4880ff71c92a5df93e1e244f7a60bf409b57e4e7ae5ebe771fb9",
  4: "240a0b98aba108024499b5d014f8743fb0b23c27f46f4179723f2032edbe36be",
  5: "86cdaaf3ab97d47977cf1b41460a3d7fc8e8d51d51117dd037efdcc21d32e02c",
  6: "d4cadbe2a2c0f566bd451a07a26cec1ffbd61d856b3a31553b24fb4ce0aec9d9",
  7: "3aaca6a95e144ae59afbe7c5cdca0739e1dc477b015321ab88e463a6671c7637",
  8: "23527033817d57723ab1725b8d35440c2d998c3b293603926cb199aadb080d61",
  9: "208a83d8e7a6f63ed11ef49210c0bc64d9bb9fca665fc3711be58aebca3ccb10",
  10: "ba7c904a98bc7cef5df95af9b9e3fafba1733568bbd40f6fb3343f3a7d628201",
};

/** Lazy loaders: the client only downloads the chapter being played. */
export const COLOR_PACK_LOADERS: Readonly<Record<number, () => Promise<ColorPack>>> = {
  1: () => import("../../packs/colors/colors-1.0.0/chapter-01.json").then((m) => m.default as ColorPack),
  2: () => import("../../packs/colors/colors-1.0.0/chapter-02.json").then((m) => m.default as ColorPack),
  3: () => import("../../packs/colors/colors-1.0.0/chapter-03.json").then((m) => m.default as ColorPack),
  4: () => import("../../packs/colors/colors-1.0.0/chapter-04.json").then((m) => m.default as ColorPack),
  5: () => import("../../packs/colors/colors-1.0.0/chapter-05.json").then((m) => m.default as ColorPack),
  6: () => import("../../packs/colors/colors-1.0.0/chapter-06.json").then((m) => m.default as ColorPack),
  7: () => import("../../packs/colors/colors-1.0.0/chapter-07.json").then((m) => m.default as ColorPack),
  8: () => import("../../packs/colors/colors-1.0.0/chapter-08.json").then((m) => m.default as ColorPack),
  9: () => import("../../packs/colors/colors-1.0.0/chapter-09.json").then((m) => m.default as ColorPack),
  10: () => import("../../packs/colors/colors-1.0.0/chapter-10.json").then((m) => m.default as ColorPack),
};
